import { render, staticRenderFns } from "./curso-show.vue?vue&type=template&id=33b5bf93&"
import script from "./curso-show.vue?vue&type=script&lang=js&"
export * from "./curso-show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports